import {
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

const defaultTenantId = "fc5981b5-b042-4d0d-900a-05d187d5679e";
const defaultClientId = "ba219bc1-ea59-4dd3-9cc3-4c48ec3f1d3b";
const defaultApiScope =
  "api://a3a2ef32-84e1-456c-9bd4-63eb9b4d0fec/access_as_user";

export const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || defaultTenantId;
export const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID || defaultClientId;
export const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE || defaultApiScope;
export const redirectUri =
  process.env.REACT_APP_ENTRA_REDIRECT_URI || window.location.origin;

export const loginRequest = {
  scopes: [apiScope],
};

const silentRecoveryErrorCodes = new Set([
  "timed_out",
  "iframe_closed_prematurely",
  "silent_prompt_value_error",
  "no_tokens_found",
  "login_required",
  "consent_required",
  "interaction_required",
]);

const staleSessionErrorCodes = new Set([
  "timed_out",
  "iframe_closed_prematurely",
  "silent_prompt_value_error",
  "no_tokens_found",
]);

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export function selectAccount(instance, accounts) {
  const activeAccount = instance.getActiveAccount();
  if (activeAccount) return activeAccount;
  const account = accounts && accounts.length > 0 ? accounts[0] : null;
  if (account) instance.setActiveAccount(account);
  return account;
}

export function requiresInteractiveToken(error) {
  return error instanceof InteractionRequiredAuthError
    || Boolean(error && silentRecoveryErrorCodes.has(error.errorCode || error.code));
}

export function requiresFreshLogin(error) {
  return Boolean(error && staleSessionErrorCodes.has(error.errorCode || error.code));
}

export async function acquireApiToken(instance, accounts) {
  const account = selectAccount(instance, accounts);
  if (!account) throw new Error("Entra account is not authenticated");

  try {
    const result = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return result.accessToken;
  } catch (error) {
    if (requiresFreshLogin(error)) {
      // A silent iframe/cache failure can leave MSAL holding an account whose
      // refresh grant has been revoked. Do not feed that stale account back as
      // a login hint: start a clean account selection instead.
      instance.setActiveAccount(null);
      await instance.loginRedirect({
        ...loginRequest,
        prompt: "select_account",
      });
    } else if (requiresInteractiveToken(error)) {
      await instance.acquireTokenRedirect({
        ...loginRequest,
        account,
      });
    }
    throw error;
  }
}
